module.exports = __webpack_public_path__ + "static/media/Banner-Mobile-Minha-Claro-Channels.5168a8ec.png";